export const types = {
  SET_DATE: 'accrualReport/SET_DATE',
  SET_SHOW_COMPLETED_JOBS: 'accrualReport/SET_SHOW_COMPLETED_JOBS',
};

export const setDate = (date) => {
  return {
    type: types.SET_DATE,
    date,
  };
};

export const setShowCompletedJobs = (showCompletedJobs) => {
  return {
    type: types.SET_SHOW_COMPLETED_JOBS,
    showCompletedJobs,
  };
};
